import { render, staticRenderFns } from "./KpiCard.vue?vue&type=template&id=875d2f10&scoped=true"
import script from "./KpiCard.vue?vue&type=script&lang=js"
export * from "./KpiCard.vue?vue&type=script&lang=js"
import style0 from "./KpiCard.vue?vue&type=style&index=0&id=875d2f10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875d2f10",
  null
  
)

export default component.exports